import { createSlice } from "@reduxjs/toolkit";
import { getInferenceItemStatus } from "../../../components/Common/helpers";

// import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

const initialState = {
  customersData: {},
  selectedCustomer: {},
  selectedDistributionCenter: {},
  loadingPalletsData: false,
  palletsData: {},
  routesData:{},
  wrappersData:{},
  operatorsData:{},
  loadingPalletsDetails: false,
  palletInferenceID: "",
  palletDetails: {},
  workItemDetails: null,
  goBackToPalletReview: false,
  pageSubTitle: "",
  isStartRefresh: false,
  isStopScanPallet:false,
  vorReferenceNumber: "",
  skuImportFileList: [],
  mappingTriageSkus: [],
  mappingTriageSkuPallets: [],
  selectedMappingTriageSku: null,
  mappingTriageSuggestMerge: null,
  loadingMappingTriageSuggestMerge: false,
  mappingTriageSkuPhotos: null,
  croppedSkuImages: [],
  selectedRectangleData: null,
  skuDashboardData: null,
  loadingSkuDashboard: false,
  skuDashboardError: "",
};

export const PalletReviewReducer = createSlice({
  name: "palletReview",
  initialState,
  reducers: {
    setCustomers: (state, action) => {
      state.customersData = action.payload;
    },
    setWorkItems: (state, action) => {
      // Sort work items in descending order by transaction_date (newest first)
      const sortedItems = Array.isArray(action.payload) 
        ? [...action.payload].sort((a, b) => {
            // Convert transaction_date strings to Date objects for comparison
            const aDate = a.transaction_date ? new Date(a.transaction_date) : new Date(0);
            const bDate = b.transaction_date ? new Date(b.transaction_date) : new Date(0);
            return bDate - aDate; // Descending order (newest date first)
          })
        : action.payload;
      state.workItemsData = sortedItems;
    },
    setWorkItemDetails: (state, action) => {
      state.workItemDetails = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setSelectedSKUItemId: (state, action) => {
      state.selectedSKUItemId = action.payload;
    },
    setCustomerId: (state, action) => {
      state.customerId = action.payload;
    },
    setSelectedDistributionCenter: (state, action) => {
      state.selectedDistributionCenter = action.payload;
    },
    setLoadingPalletsData: (state, action) => {
      state.loadingPalletsData = action.payload;
    },
    setPalletsData: (state, action) => {
      state.palletsData = action.payload;
    },
    clearPalletsData: (state, action) => {
      state.palletsData = [];
    },

    setRoutesData: (state, action) => {
      state.routesData = action.payload;
    },

    setWrapperData: (state, action) => {
      state.wrappersData = action.payload;
    },
    setOperatorsData: (state, action) => {
      state.operatorsData = action.payload;
    },


    setLoadingPalletsDetails: (state, action) => {
      state.loadingPalletsDetails = action.payload;
    },

    setCreateWorkOrderDetails: (state, action) => {
      state.workOrderDetailsLoading = action.payload;
    },

    
    setPalletInferenceID: (state, action) => {
      state.palletInferenceID = action.payload;
    },
    setBrandList: (state, action) => {
      state.brandList = action.payload;
    },
    setPackageTypeList: (state, action) => {
      state.packageTypeList = action.payload;
    },
    setPalletDetails: (state, action) => {
      if (action.payload.inference_result !== undefined) {
        let sortedResult = action.payload.inference_result.sort((a, b) => {
          const aStatus = getInferenceItemStatus(a),
            bStatus = getInferenceItemStatus(b);
          if (aStatus === bStatus) return 0;

          const statusOrder = [
            "Audited",
            "Extra",
            "Missing",
            "Untrained",
            "Can’t confirm",
            "No error",
          ];

          const aOrder = statusOrder.indexOf(aStatus),
            bOrder = statusOrder.indexOf(bStatus);
          console.log(aOrder, bOrder)
          if (aOrder === -1 || bOrder === -1) return 0;

           return aOrder > bOrder ? 1 : -1;

        })
        action.payload.inference_result = sortedResult
      }
      state.palletDetails = action.payload;

    },
    setGoBackToPalletReview: (state, action) => {
      state.goBackToPalletReview = action.payload;
    },
    setPageSubTitle: (state, action) => {
      state.pageSubTitle = action.payload;
    },
    setPageChildTitle: (state, action) => {
      state.pageChildTitle = action.payload;
    },
    setStartRefresh: (state, action) => {
      state.isStartRefresh = action.payload;
    },
    setStopScanPallet: (state, action) => {
      state.isStopScanPallet = action.payload;
    },
    setVorReferenceNumber: (state, action) => {
      state.vorReferenceNumber = action.payload;
    },
    setSkuImportFileList: (state, action) => {
      state.skuImportFileList = action.payload ?? [];
    },
    setSKUFileDetails: (state, action) => {
      state.skuFileDetails = action.payload ?? [];
    },
    setMappingTriageSkus: (state, action) => {
      state.mappingTriageSkus = action.payload ?? [];
    },
    setMappingTriageSkuPallets: (state, action) => {
      const payload = action.payload;
      state.mappingTriageSkuPallets = Array.isArray(payload) ? payload : [];
    },
    setPalletImagesCache: (state, action) => {
      const { picklistId, customerId, images } = action.payload || {};
      if (!state.palletImagesCache) state.palletImagesCache = {};
      if (picklistId && images) {
        // Key by customer + picklist since customer_picklist_id is not unique
        // across customers. Also store under the bare picklistId for backward
        // compatibility with any reader that has no customer context.
        const scopedKey = customerId != null ? `${customerId}:${picklistId}` : String(picklistId);
        state.palletImagesCache[scopedKey] = images;
      }
    },
    setSelectedMappingTriageSku: (state, action) => {
      state.selectedMappingTriageSku = action.payload ?? null;
    },
    setMappingTriageSuggestMerge: (state, action) => {
      state.mappingTriageSuggestMerge = action.payload ?? null;
    },
    setLoadingMappingTriageSuggestMerge: (state, action) => {
      state.loadingMappingTriageSuggestMerge = action.payload ?? false;
    },
    setMappingTriageSkuPhotos: (state, action) => {
      state.mappingTriageSkuPhotos = action.payload ?? null;
    },
    addCroppedSkuImage: (state, action) => {
      // payload: { vorRefNumber, pose, orientation, dataUrl, timestamp }
      // Replace existing entry with same vorRefNumber + pose + orientation, or add new
      const { vorRefNumber, pose, orientation } = action.payload;
      const idx = state.croppedSkuImages.findIndex(
        (img) => img.vorRefNumber === vorRefNumber && img.pose === pose && img.orientation === orientation
      );
      if (idx >= 0) {
        state.croppedSkuImages[idx] = action.payload;
      } else {
        state.croppedSkuImages.push(action.payload);
      }
    },
    clearCroppedSkuImages: (state) => {
      state.croppedSkuImages = [];
    },
    updateCroppedSkuImageVorRef: (state, action) => {
      // payload: { oldVorRef, newVorRef }
      const { oldVorRef, newVorRef } = action.payload;
      state.croppedSkuImages = state.croppedSkuImages.map(img =>
        img.vorRefNumber === oldVorRef ? { ...img, vorRefNumber: newVorRef } : img
      );
    },
    setSelectedRectangleData: (state, action) => {
      state.selectedRectangleData = action.payload ?? null;
    },
    setSkuDashboardData: (state, action) => {
      state.skuDashboardData = action.payload ?? null;
    },
    setLoadingSkuDashboard: (state, action) => {
      state.loadingSkuDashboard = action.payload ?? false;
    },
    setSkuDashboardError: (state, action) => {
      state.skuDashboardError = action.payload ?? "";
    },
  },
});

// Action creators are generated for each case reducer function.
export const {
  setCustomers,
  setWorkItems,
  setWorkItemDetails,
  setCustomerId,
  setSelectedCustomer,
  setSelectedSKUItemId,
  setSelectedDistributionCenter,
  setLoadingPalletsData,
  setPalletsData,
    clearPalletsData,
  setRoutesData,
    setWrapperData,
  setOperatorsData,
  setLoadingPalletsDetails,
  setCreateWorkOrderDetails,
  setBrandList,
  setPackageTypeList,
  setPalletInferenceID,
  setPalletDetails,
  setGoBackToPalletReview,
  setPageSubTitle,
  setPageChildTitle,
  setStartRefresh,
  setStopScanPallet,
  setVorReferenceNumber,
  setSkuImportFileList,
  setSKUFileDetails,
  setMappingTriageSkus,
  setMappingTriageSkuPallets,
  setPalletImagesCache,
  setSelectedMappingTriageSku,
  setMappingTriageSuggestMerge,
  setLoadingMappingTriageSuggestMerge,
  setMappingTriageSkuPhotos,
  addCroppedSkuImage,
  clearCroppedSkuImages,
  updateCroppedSkuImageVorRef,
  setSelectedRectangleData,
  setSkuDashboardData,
  setLoadingSkuDashboard,
  setSkuDashboardError,
} = PalletReviewReducer.actions;

// export const selectCustomersData = (state) => state.palletReview.customersData;

export default PalletReviewReducer.reducer;
